import {
  Avatar,
  Box,
  IconButton,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { DamsAppAsset } from "../../assets/registry";
import { DamsColors } from "../styles/DamsColors";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { MenuItem } from "./SideBarList";
import { navIcons } from "../../config/constants/nav-pages";

type SideBarItemProps = {
  menu: MenuItem;
  selected: boolean;
  onClick?: () => void;
  children?: MenuItem[];
  open?: boolean;
  isChild?: boolean;
};

function SideBarItem({
  menu = { title: "menu", path: "/" ,icon:navIcons.dashboard},
  selected = false,
  onClick,
  children,
  open = false,
  isChild = false,
}: Readonly<SideBarItemProps>): JSX.Element {
  let IconSrc=menu.icon



  return (
    <IconButton  onClick={onClick} sx={styles.touchable}>
    <ListItem
     
      sx={{
        ...styles.listItem,
        ...(selected && styles.listItemActive),
        ...(isChild && styles.listItemChild),
        "&:hover": styles.listItemActive,
      }}
    >
      <Avatar
        src={selected ? IconSrc.active : IconSrc.innactive}
        sx={styles.avatar}
        variant="square"
      />

      <ListItemText
        sx={{
          ...styles.itemText,
          ...(selected && styles.itemTextActive),
          ...(isChild && styles.itemTextChild),
        }}
        primary={menu.title}
      />

      {menu.title.toLowerCase() === "notifications" && (
        <Typography
          fontFamily={"Inter"}
          fontWeight={"500"}
          fontSize={12}
          color={DamsColors.Text.Highlight}
          border={"1px solid transparent"}
          borderRadius={"20%"}
          p={1}
          sx={styles.notificationText}
        >
          200
        </Typography>
      )}

      {menu.children &&
        (open ? (
          <ExpandLess sx={{ color: DamsColors.Text.Highlight }} />
        ) : (
          <ExpandMore sx={{ color: DamsColors.Text.Highlight }} />
        ))}
    </ListItem>
    </IconButton>
  );
}

function FooterItem({
  logoutBtn,
  userName,
  userTitle,
}: {
  logoutBtn: () => void;
  userName: string;
  userTitle: string;
}) {
  return (
    <ListItem sx={styles.footerItem}>
      <Box flexGrow={1}>
        <Typography
          fontFamily={"Inter"}
          fontSize={14}
          fontWeight={"600"}
          color={DamsColors.Text.PrimaryText}
        >
          {userName}
        </Typography>

        <Typography
          fontFamily={"Inter"}
          fontSize={14}
          fontWeight={"400"}
          color={DamsColors.Text.LabelTextLight}
        >
          {userTitle}
        </Typography>
      </Box>

      <IconButton onClick={() => logoutBtn()}>
        <Avatar
          alt="logout"
          src={DamsAppAsset.icons.logout}
          sx={styles.logoutIcn}
          variant="square"
        />
      </IconButton>
    </ListItem>
  );
}




const styles = {
  avatar: {
    width: "24px",
    height: "24px",
    mr: 2,
  },

  listItem: {
    p: "8px 12px ",
    mb: "4px",
    cursor: "pointer",
  },

  listItemActive: {
    borderRadius: "8px",
    backgroundColor: DamsColors.Background.Notification,
  },

  listItemChild: {
    pl: 4,
  },

  itemText: {
    "& .MuiListItemText-primary": {
      fontWeight: "600",
      fontFamily: "Inter",
      fontSize: 16,
      color: DamsColors.Text.PrimaryText,
    },
  },

  itemTextActive: {
    "& .MuiListItemText-primary": {
      fontWeight: "600",
      fontFamily: "Inter",
      fontSize: 16,
      color: DamsColors.Text.Highlight,
    },
  },

  itemTextChild: {
    "& .MuiListItemText-primary": {
      fontSize: 14,
    },
  },

  notificationText: {
    backgroundColor: DamsColors.Background.Notification,
  },

  footerItem: {
    height: "40px",
  },

  userImg: {
    width: "40px",
    Height: "40px",
    mr: 2,
  },

  logoutIcn: {
    width: "24px",
    height: "24px",
  },
  touchable:{
    padding:0,width:'100%',
    borderRadius:0
  }
};

export { SideBarItem, FooterItem };
